<template lang="">
  <router-view></router-view>
</template>

<script>
export default {

  name: 'DialogoDesempeno',
  data () {
    return {
    }
  }
  
};
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/views/dialogo-desempeno.vue